var render = function render(){var _vm=this,_c=_vm._self._c;return _c('checkout-layout',[_c('div',{staticClass:"user-identification"},[_c('checkout-headline',{attrs:{"title":_vm.$t('checkout.identifyUser.title'),"text":_vm.$t('checkout.identifyUser.text')}}),_c('user-identification-wrapper',{on:{"update-component":_vm.updateComponent}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }